import "@popperjs/core";
$(function () {
    $('[data-toggle="tooltip"]').tooltip({ delay: { show: 100, hide: 100 } });
});
